module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-pages"
  }, [_c('div', {
    staticClass: "hero-pages__overlay",
    class: {
      "hero-pages__overlay--covid": _vm.$route.path.includes("/covid-19-updates"), "hero-pages__overlay--virtual-services": _vm.$route.path.includes("/virtual-services"), "hero-pages__overlay--virtual-consultation": _vm.$route.path.includes("/virtual-consultation"), "hero-pages__overlay--7-and-up": _vm.$route.path.includes("/7-and-up"), "hero-pages__overlay--videos": _vm.$route.path.includes("/videos")
    }
  }, [_c('div', {
    staticClass: "hero-pages__container"
  }, [_c('h2', {
    staticClass: "hero-pages__title"
  }, [_vm._v(_vm._s(_vm.$route.name))]), (_vm.props && _vm.$route.path.includes("/covid-19-updates")) ? _c('div', {
    staticClass: "hero-pages__buttons"
  }, _vm._l((_vm.props.acf.covid_19_header_buttons), function(button, i) {
    return _c('a', {
      key: "button " + i,
      staticClass: "hero-pages__button",
      attrs: {
        "href": button.button.href,
        "target": "_blank"
      },
      domProps: {
        "innerHTML": _vm._s(button.button.label)
      }
    })
  }), 0) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20d0dffd","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero-pages/hero-pages.pug
// module id = 681
// module chunks = 1